<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h2>Kampanya Güncelle</h2>

      <v-row style="margin-top: 50px;">
        <v-col cols="12" md="4">
          <h4>Kampanya Başlık</h4>
          <v-text-field
            v-model="merchantCampaign.title"
            maxlength="255"
            counter="255"
            :rules="titleRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <h4>Mobil Başlık</h4>
          <v-text-field
            v-model="merchantCampaign.shortDescription"
            maxlength="255"
            counter="255"
            :rules="shortDescriptionRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <div class="tooltip-container">
            <h4>Son Kullanım Tarihi</h4>
            <v-tooltip
              v-if="tooltipMessage.message"
              bottom
              v-model="showTooltip"
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  :style="{ color: tooltipMessage.color }"
                  v-on="on"
                  @mouseenter="showTooltip = true"
                  @mouseleave="showTooltip = false"
                >
                  {{ tooltipMessage.icon }}
                </v-icon>
              </template>
              <span>{{ tooltipMessage.message }}</span>
            </v-tooltip>
          </div>

          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="merchantCampaign.endDate"
                label="Son Kullanım Tarihi"
                style="font-weight: bold;"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="merchantCampaign.endDate"
              :min="new Date().toISOString().substring(0, 10)"
              @input="menu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4"></v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <h4>Açıklama</h4>
          <v-textarea
            v-model="merchantCampaign.description"
            maxlength="2000"
            rows="1"
            auto-grow
            counter="2000"
            :rules="descriptionRules"
            required
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <h4>
            Link
            <v-icon
              style="font-size: 17px;"
              v-if="!alertLink"
              color="#4d48f9"
              @click="alertLink = true"
            >
              info
            </v-icon>

            <v-alert
              v-model="alertLink"
              border="left"
              close-text="Close Alert"
              color="#4d48f9"
              dark
              dismissible
            >
              Dış Link eklerken http, https protokollerinin girilmesi
              gereklidir.
              <br />
              Örneğin: http://frink.com.tr, https://frink.com.tr
            </v-alert>
          </h4>
          <v-text-field
            v-model="merchantCampaign.link"
            maxlength="255"
            counter="255"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" sm="3">
          <h4>Link tipi</h4>
          <v-select
            v-model="merchantCampaign.campaignLinkType"
            :items="campaignLinkTypes"
            :disabled="!merchantCampaign.link"
            item-text="name"
            item-value="value"
            label="Link Tipi"
            data-vv-name="select"
            required
          ></v-select>
        </v-col>

        <v-col cols="12" md="4">
          <h4>Link Metni</h4>
          <v-text-field
            v-model="merchantCampaign.linkText"
            :disabled="!merchantCampaign.link"
            maxlength="255"
            counter="255"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3">
          <h4>
            Öncelik
            <v-icon
              style="font-size: 17px;"
              v-if="!alertPriority"
              color="#4d48f9"
              @click="alertPriority = !alertPriority"
            >
              info
            </v-icon>

            <v-alert
              v-model="alertPriority"
              border="left"
              close-text="Close Alert"
              color="#4d48f9"
              dark
              dismissible
            >
              Kampanyanın uygulamadaki sırasını belirtir.
            </v-alert>
          </h4>
          <v-text-field
            v-model="merchantCampaign.sortOrder"
            type="number"
            min="0"
            required
            @input="handleInput"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="3">
          <h4>Ana Sayfada Göster</h4>
          <v-checkbox
            v-model="merchantCampaign.isShownHomePage"
            color="#4d48f9"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" md="3">
          <h4>Aktif/Pasif</h4>
          <v-checkbox
            v-model="merchantCampaign.active"
            color="#4d48f9"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <h4>
            Görsel
            <v-icon
              style="font-size: 17px;"
              v-if="!infoImage"
              color="#4d48f9"
              @click="infoImage = true"
            >
              info
            </v-icon>
          </h4>

          <v-alert
            v-model="infoImage"
            border="left"
            close-text="Close Alert"
            color="#4d48f9"
            dark
            dismissible
          >
            Görsel boyutu: 654x400
            <br />
            Format: JPG
            <br />
            Dosya boyutu: Maximum 350 KB
          </v-alert>
          <v-img
            style="cursor: pointer;"
            v-if="
              (imgUrl !== '' && imgUrl !== undefined) ||
              (merchantCampaign.img !== '' &&
                merchantCampaign.img !== undefined)
            "
            :src="imgUrl ? imgUrl : merchantCampaign.img"
            aspect-ratio="1.7"
          ></v-img>
          <v-file-input
            show-size
            accept="image/*"
            v-model="merchantCampaign.img"
            @change="previewFiles"
            label="Resim yükle"
            required
          ></v-file-input>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-btn
            depressed
            color="#4d48f9"
            style="text-transform: none !important; float: left; color: white;"
            @click="campaignUpdate()"
          >
            GÜNCELLE
          </v-btn>
        </v-col>
        <!-- <v-col cols="12" md="4">
          <v-btn
            depressed
            style="text-transform: none !important; float: left; color: white;background-color: #438726"
            @click="exportExcel()"
          >EXPORT
          </v-btn>
        </v-col> -->
      </v-row>

      <v-dialog v-model="dialog" max-width="600">
        <v-card>
          <v-card-title class="headline">
            Lütfen alanları kontrol edin
          </v-card-title>

          <v-card-text>
            <ul>
              <li v-for="errorList in this.errorList" :key="errorList">
                {{ errorList }}
              </li>
            </ul>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- <v-row>

      </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CampaignDetail',
  data: () => ({
    alert: false,
    infoImage: false,
    alertPriority: false,
    alertLink: false,
    valid: true,
    imgUrl: '',
    couponCodeCount: 1,
    codeUsedCount: 0,
    codeCreated: false,
    showToolTip: false,
    titleRules: [
      (v) => !!v || 'Başlık alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    descriptionRules: [
      (v) => !!v || 'Açıklama alanı zorunludur.',
      (v) => v.length <= 2000 || 'Maksimum 2000 karakter olmalıdır.',
    ],
    shortDescriptionRules: [
      (v) => !!v || 'Kısa açıklama alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    fileRules: [
      // value => value.size < 1000 || 'Avatar size should be less than 2 MB!',
      (v) => !!v || 'Resim gereklidir.',
      (v) => (v && v.name != null) || 'Resim gereklidir.',
    ],
    orderRules: [(v) => parseFloat(v) > -1 || "Adet 0'dan küçük olmamalıdır."],
    discountRules: [
      (v) =>
        parseFloat(v) >= 1 ||
        'İndirim tutarı en az 1 en fazla 25000 olmalıdır.',
      (v) =>
        parseFloat(v) <= 25000 ||
        'İndirim tutarı en az 1 en fazla 25000 olmalıdır.',
    ],
    codeRules: [
      (v) => !!v || 'Kampanya kodu alanı zorunludur.',
      (v) =>
        /^\w+$/.test(v) ||
        'Genel kod yalnızca ingilizce karakterlerden oluşmalıdır.',
      (v) => v.length >= 6 || 'Genel kod 6-8 karakter olmalıdır.',
      (v) => v.length <= 8 || 'Genel kod 6-8 karakter olmalıdır.',
    ],
    noRule: [],
    usageCountLimitOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    // imgUrl: '',
    imageRules: [
      (v) => !!v || 'Resim alanı zorunludur.',
      (v) =>
        (v && v.size <= 350 * 1024) ||
        'Dosya boyutu en fazla 350 KB olmalıdır.',
    ],
    campaignLinkTypes: [
      {
        name: 'İç Link',
        value: 'InternalLink',
      },
      {
        name: 'Dış Link',
        value: 'ExternalLink',
      },
    ],
    menu: false,
    codeTypeList: [
      {
        name: 'Genel Kod',
        value: 'General',
      },
      {
        name: 'Unique Kod',
        value: 'Unique',
      },
      {
        name: 'No Code',
        value: 'NoCode',
      },
    ],
    errorList: [],
    dialog: false,
  }),
  computed: {
    ...mapGetters([
      'merchantCampaign',
      'allSubscriptionTypes',
      'subscriptionLabels',
    ]),
    tooltipMessage() {
      const endDate = new Date(this.merchantCampaign.endDate)
      const today = new Date()
      const oneWeekFromNow = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000)
      if (endDate < today) {
        return {
          message: 'Bu kampanya süresi sona erdi',
          icon: 'mdi-exclamation',
          color: 'crimson',
        }
      } else if (endDate <= oneWeekFromNow) {
        return {
          message: 'Bu kampanya yakında sonlanacaktır',
          icon: 'mdi-timelapse',
          color: '#FFCD3F',
        }
      }
      return { message: '', icon: '', color: 'white' }
    },
  },
  created() {
    let campaign = {
      id: this.$route.params.id,
    }
    this.getMerchantCampaign(campaign).then((data) => {
      this.imgUrl = data.imgUrl

      // this.campaignImgUrl = data.imgUrl;
      // this.codeUsedCount = data.codeUsedCount;
      // this.codeCreated = data.codeCreated;
      // if (this.merchantCampaign.codeType === "Unique")
      //   this.merchantCampaign.userCount = 1;
    })
    // for (let i = 1; i <= 100; i++) {
    //   this.couponCodeList.push({
    //     name: i.toString(),
    //     value: i
    //   });
    // }
  },
  methods: {
    ...mapActions(['getMerchantCampaign', 'updateMerchantCampaign']),
    handleInput(item) {
      if (item.includes('.'))
        this.merchantCampaign.userCount = item.replace('.', '')
    },
    routeCampaigns() {
      this.$router.push('/dashboard/merchant-campaigns')
    },
    // redirectImagePath(endpoint) {
    //   window.location.href = endpoint;
    // },
    // getBase64(file) {
    //   return new Promise((resolve, reject) => {
    //     const reader = new FileReader();
    //     reader.readAsDataURL(file);
    //     reader.onload = () => resolve(reader.result.split(",")[1]);
    //     reader.onerror = (error) => reject(error);
    //   });
    // },
    previewFiles() {
      if (this.merchantCampaign.img === undefined) {
        this.imgUrl = ''
      } else {
        const file = this.merchantCampaign.img
        this.imgUrl = URL.createObjectURL(file)
      }
    },
    campaignUpdate() {
      if (this.$refs.form.validate()) {
        if (
          this.merchantCampaign.link !== '' &&
          this.merchantCampaign.linkText === ''
        ) {
          alert('Link metni alanı dolu olmalıdır')
          return
        }

        this.snackbar = true
        this.updateMerchantCampaign(this.merchantCampaign)
          .then((response) => {
            if (response.payload) {
              this.routeCampaigns()
            } else {
              alert(response.friendlyMessage.message)
            }
          })
          .catch((err) => {
            const errors = err.response.data.errors
            if (errors && Object.keys(err.response.data.errors).length) {
              if (errors['Link']) {
                alert('Link alanını kontrol edin')
                return
              }
              if (errors['EndDate']) {
                if (errors['EndDate'] == 'check_end_date') {
                  alert('Son kontrol tarihini kontrol edin')
                  return
                }
              }
            }
            alert(err)
          })
      } else {
        var errors = []
        var x = document.getElementsByClassName('v-messages__message')
        for (var i = 0; i < x.length; i++) errors.push(x[i].innerHTML)
        this.errorList = errors
        this.dialog = true
      }
    },
  },
}
</script>

<style scoped>
.tooltip-container {
  display: flex;
}

.tooltip-icon {
  font-size: 24px;
  color: red;
  cursor: pointer;
}

.tooltip-icon:hover {
  color: darkred;
}
</style>
